import Swiper from 'swiper';
import UiHelper from './UiHelper';

const selectors = {
    wrap: '.js-image-slider',
    prev: '.js-image-slider__prev',
    next: '.js-image-slider__next'
}

class ImageSliderFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes(selectors.wrap)).forEach(wrap =>
        {
            new ImageSlider(wrap);
        });
    }
}
export default ImageSliderFactory;

class ImageSlider
{
    constructor(wrap)
    {
        this.swiper = new Swiper(wrap, {
            speed: 500,
            loop: true
        });

        this.prev = wrap.querySelector(selectors.prev);
        this.next = wrap.querySelector(selectors.next);

        this.prev.addEventListener('click', e => { this.swiper.slidePrev(); });
        this.next.addEventListener('click', e => { this.swiper.slideNext(); });
    }
}
